export interface IGetDevicePositionsEventsQueryDto {
    from: string;
    to: string;
    deviceIds: string;
}
